import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { readCampaignFromUrl } from "@/lib/campaign";

// Pure read-only helper. The actual analytics tracking + scroll behaviour
// is performed once in AnalyticsProvider — do NOT duplicate side effects here.
// Use this hook whenever a page needs to react to ?focus, ?intent or ?utm
// (e.g. KidsRegistrationPage uses `intent` to pre-select a tab).
export function useCampaign() {
  const { search } = useLocation();
  const params = readCampaignFromUrl(search);
  // empty effect kept so consumers can be confident the hook re-runs on URL change
  useEffect(() => {}, [search]);
  return params;
}
